import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  JoinWaitlistDto,
  WaitlistCountResponseDto,
  WaitlistResponseDto,
} from '@nomiss/sdk';
import { getWaitlistCount, joinWaitlist } from '@nomiss/services';

export const useJoinWaitlist = () => {
  const queryClient = useQueryClient();
  const joinWaitlistMutation = useMutation({
    mutationFn: (data: JoinWaitlistDto) => joinWaitlist(data),
    onSuccess: (data: WaitlistResponseDto) => {
      if (!data.data?.isNew) return;
      queryClient.setQueryData<WaitlistCountResponseDto>(
        ['waitlist', 'count'],
        (old) => {
          if (!old) return old;
          return {
            ...old,
            data: old.data
              ? { ...old.data, count: old.data.count + 1 }
              : old.data,
          };
        },
      );
    },
  });
  return { joinWaitlistMutation };
};

export const useWaitlistCount = () => {
  const waitlistCountQuery = useQuery({
    queryKey: ['waitlist', 'count'],
    queryFn: () => getWaitlistCount(),
  });
  return { waitlistCountQuery };
};
